// extracted by mini-css-extract-plugin
export var numpadContainer = "_ov-1";
export var phoneButton = "_ov-0";